import { render } from "./propertiesRadio.vue?vue&type=template&id=6b683a03"
import script from "./propertiesRadio.vue?vue&type=script&lang=js"
export * from "./propertiesRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__